export const GraphQL = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path
        fill="#55565C"
        d="m3.325 14.803-.672-.389L10.15 1.431l.673.39-7.496 12.982Z"
      />
      <path fill="#55565C" d="M2.5 13.378h14.993v.777H2.5v-.777Z" />
      <path
        fill="#55565C"
        d="m10.296 18.144-7.5-4.33.39-.672 7.499 4.329-.389.673ZM16.811 6.86l-7.5-4.33.39-.672 7.499 4.33-.39.672Z"
      />
      <path
        fill="#55565C"
        d="m3.187 6.856-.389-.672 7.506-4.325.388.673-7.505 4.325Z"
      />
      <path
        fill="#55565C"
        d="M16.672 14.803 9.176 1.82l.672-.389 7.496 12.983-.672.39ZM3.095 5.67h.776v8.66h-.776v-8.66Zm13.031 0h.777v8.66h-.777v-8.66Z"
      />
      <path
        fill="#55565C"
        d="m10.163 17.815-.34-.588 6.523-3.766.34.589-6.523 3.765Z"
      />
      <path
        fill="#55565C"
        d="M17.933 14.58a1.636 1.636 0 0 1-2.832-1.633 1.636 1.636 0 0 1 2.233-.6 1.63 1.63 0 0 1 .6 2.234ZM4.893 7.05a1.636 1.636 0 0 1-2.995-.394 1.636 1.636 0 0 1 1.155-2.002 1.636 1.636 0 0 1 1.24.163 1.638 1.638 0 0 1 .6 2.233Zm-2.827 7.53a1.637 1.637 0 0 1 .6-2.232 1.637 1.637 0 0 1 2.232.6 1.635 1.635 0 0 1-2.833 1.633Zm13.04-7.53a1.637 1.637 0 0 1 .6-2.233 1.637 1.637 0 0 1 2.233.6 1.636 1.636 0 0 1-2.833 1.633ZM9.999 19.165a1.633 1.633 0 1 1 0-3.268 1.633 1.633 0 0 1 0 3.268Zm0-15.063a1.633 1.633 0 1 1 0-3.268 1.633 1.633 0 0 1 0 3.268Z"
      />
    </svg>
  )
}
